import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const CetakKartu = ({ token }) => {
  const { id } = useParams(); // Ambil ID dari URL (kalau ada)
  const navigate = useNavigate();
  
  const [siswa, setSiswa] = useState(null);
  
  // State untuk pencarian (Jika masuk lewat Sidebar)
  const [allSiswa, setAllSiswa] = useState([]);
  const [keyword, setKeyword] = useState('');

  // 1. Jika ada ID di URL, ambil data siswa tersebut
  useEffect(() => {
    if (id) {
        axios.get(`https://sijapan.sman10fajarharapan.sch.id/api/siswa/${id}`, { headers: { Authorization: `Bearer ${token}` } })
        .then(res => setSiswa(res.data))
        .catch(err => console.error(err));
    } else {
        // Jika TIDAK ada ID (Lewat Sidebar), ambil semua siswa buat pencarian
        axios.get(`https://sijapan.sman10fajarharapan.sch.id/api/siswa`, { headers: { Authorization: `Bearer ${token}` } })
        .then(res => setAllSiswa(res.data))
        .catch(err => console.error(err));
    }
  }, [id, token]);

  // --- TAMPILAN 1: PENCARIAN (Kalau belum pilih siswa) ---
  if (!id) {
    const filtered = allSiswa.filter(s => s.nama.toLowerCase().includes(keyword.toLowerCase()) || s.kelas.toLowerCase().includes(keyword.toLowerCase()));
    
    return (
        <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
            <h2 style={{ textAlign: 'center', color: '#1e293b' }}>🪪 Cetak Kartu Pelajar</h2>
            <input 
                type="text" 
                placeholder="🔍 Ketik Nama Siswa atau Kelas..." 
                value={keyword}
                onChange={e => setKeyword(e.target.value)}
                style={{ width: '100%', padding: '15px', borderRadius: '10px', border: '1px solid #cbd5e1', fontSize: '16px', marginBottom: '20px' }}
            />
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '15px' }}>
                {filtered.map(s => (
                    <div 
                        key={s.id} 
                        onClick={() => navigate(`/cetak-kartu/${s.id}`)}
                        style={{ background: 'white', padding: '15px', borderRadius: '8px', cursor: 'pointer', boxShadow: '0 2px 5px rgba(0,0,0,0.05)', border: '1px solid #e2e8f0', transition: '0.2s' }}
                    >
                        <div style={{ fontWeight: 'bold', fontSize: '16px', color: '#334155' }}>{s.nama}</div>
                        <div style={{ color: '#64748b', fontSize: '14px' }}>Kelas {s.kelas} | NIS: {s.nis}</div>
                        <div style={{ marginTop: '10px', color: '#4361ee', fontWeight: 'bold', fontSize: '12px' }}>👉 Klik untuk Cetak</div>
                    </div>
                ))}
            </div>
        </div>
    );
  }

  // --- TAMPILAN 2: PREVIEW KARTU (Kalau siswa sudah dipilih) ---
  if (!siswa) return <div style={{textAlign:'center', marginTop:'50px'}}>Memuat data kartu...</div>;

  return (
    <div className="container-kartu" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '30px' }}>
      
      {/* TOMBOL NAVIGASI */}
      <div className="no-print" style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
        <button onClick={() => navigate('/cetak-kartu')} style={{ padding: '10px 20px', background: '#94a3b8', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>
            ⬅️ Kembali Cari
        </button>
        <button onClick={() => window.print()} style={{ padding: '10px 20px', background: '#4361ee', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>
            🖨️ Print Sekarang
        </button>
      </div>

      {/* --- DESAIN KARTU PELAJAR --- */}
      <div id="kartu-pelajar" style={{ 
          width: '85.6mm', height: '53.98mm', 
          background: 'linear-gradient(135deg, #4361ee 0%, #3a0ca3 100%)', 
          borderRadius: '8px', position: 'relative', overflow: 'hidden', 
          color: 'white', fontFamily: 'Arial, sans-serif', boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
          border: '1px solid #ccc'
      }}>
        
        {/* Dekorasi Background */}
        <div style={{ position: 'absolute', top: '-20px', right: '-20px', width: '100px', height: '100px', background: 'rgba(255,255,255,0.1)', borderRadius: '50%' }}></div>
        <div style={{ position: 'absolute', bottom: '-30px', left: '-30px', width: '120px', height: '120px', background: 'rgba(255,255,255,0.1)', borderRadius: '50%' }}></div>

        {/* Header */}
        <div style={{ padding: '15px 15px 5px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ width: '40px', height: '40px', background: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#4361ee', fontWeight: 'bold', fontSize: '10px' }}>LOGO</div>
            <div>
                <h3 style={{ margin: 0, fontSize: '12px', textTransform: 'uppercase', letterSpacing: '1px' }}>SMAN 10 Fajar Harapan</h3>
                <p style={{ margin: '2px 0 0', fontSize: '8px', opacity: 0.8 }}>Kartu Tanda Pelajar</p>
            </div>
        </div>

        {/* Konten */}
        <div style={{ display: 'flex', padding: '10px 20px', gap: '15px', alignItems: 'center' }}>
            {/* Foto Placeholder */}
            <div style={{ width: '70px', height: '85px', background: 'white', borderRadius: '4px', border: '2px solid rgba(255,255,255,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ccc', fontSize: '10px' }}>
                FOTO
            </div>

            <div style={{ flex: 1 }}>
                <h2 style={{ margin: '0 0 5px', fontSize: '16px', fontWeight: '800', textTransform: 'uppercase' }}>{siswa.nama}</h2>
                <div style={{ fontSize: '10px', display: 'flex', flexDirection: 'column', gap: '3px', opacity: 0.9 }}>
                    <div><span style={{ width: '40px', display: 'inline-block' }}>NIS</span> : <b>{siswa.nis}</b></div>
                    <div><span style={{ width: '40px', display: 'inline-block' }}>Kelas</span> : <b>{siswa.kelas}</b></div>
                    <div style={{ marginTop: '5px', background: 'white', color: '#334155', padding: '2px 6px', borderRadius: '4px', display: 'inline-block', fontWeight: 'bold', fontSize: '9px' }}>
                        SISWA AKTIF
                    </div>
                </div>
            </div>
        </div>

        {/* Footer Barcode */}
        <div style={{ position: 'absolute', bottom: '10px', right: '15px', textAlign: 'right' }}>
             <div style={{ display: 'flex', gap: '2px', height: '15px', justifyContent: 'flex-end', opacity: 0.8 }}>
                {[...Array(15)].map((_,i) => (
                    <div key={i} style={{ width: Math.random() > 0.5 ? '2px' : '1px', background: 'white' }}></div>
                ))}
             </div>
             <div style={{ fontSize: '8px', marginTop: '2px', letterSpacing: '2px' }}>{siswa.nis}</div>
        </div>
      </div>

      <p className="no-print" style={{ marginTop: '10px', fontSize: '12px', color: '#64748b' }}>
        *Gunakan kertas PVC atau Kertas Foto Tebal (Setting Print: Scale 100%).
      </p>

      {/* CSS KHUSUS PRINT */}
      <style>{`
        @media print {
            .no-print, .sidebar, .hamburger-btn, .sidebar-overlay { display: none !important; }
            body { background: white; -webkit-print-color-adjust: exact; }
            .container-kartu { margin: 0; position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; }
            #kartu-pelajar { box-shadow: none; border: 1px solid #000; }
            .main-content { margin: 0; padding: 0; width: 100%; }
        }
      `}</style>
    </div>
  );
};

export default CetakKartu;